import { render, staticRenderFns } from "./card-coupons-new.vue?vue&type=template&id=2eea2306&scoped=true&lang=pug&"
import script from "./card-coupons-new.vue?vue&type=script&lang=js&"
export * from "./card-coupons-new.vue?vue&type=script&lang=js&"
import style0 from "./card-coupons-new.vue?vue&type=style&index=0&id=2eea2306&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea2306",
  null
  
)

export default component.exports